import React, { useState, useRef, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { Box, TextField, Modal, Button, Divider } from '@mui/material';
import SpeakerNotesOutlined from '@mui/icons-material/SpeakerNotesOutlined';

interface ObservacaoProps {
  observacaoInterna: string;
  retorno: string;
  handleSetObservacaoInterna: any;
  editavel: boolean;
}

const Observacao: React.FC<ObservacaoProps> = ({ observacaoInterna, retorno, handleSetObservacaoInterna, editavel }) => {
  const [observacao, setObservacao] = useState(observacaoInterna);
  const [openModal, setOpenModal] = useState(false);
  const [inputValue, setInputValue] = useState(retorno + observacao);

  const inputRef = useRef<HTMLTextAreaElement>(null);
  const saveButtonRef = useRef<HTMLButtonElement>(null);

  const handleChangeObservacao = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleSaveObservacao = () => {
    setObservacao(inputValue);
    handleSetObservacaoInterna(inputValue);
    handleCloseModal();
  };

  // foca no campo quando abrir modal
  useEffect(() => {
    if (openModal && inputRef.current) {
      inputRef.current.focus();
    }
  }, [openModal]);

  return (
    <Box
      onClick={() => {
        if (!editavel) return;
        if (!openModal) handleOpenModal();
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        width: '100%',
        height: '160px',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ width: '100%', flex: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <SpeakerNotesOutlined sx={{ fontSize: 20, color: '#0965c1' }} />
          <Typography variant="subtitle1" fontSize='15px' fontWeight={500} sx={{ lineHeight: 1 }}>
            Observação
          </Typography>
        </Box>

        <Divider sx={{ width: '100%', marginBottom: 2, marginTop: -0.4 }} />
        <Typography
          variant="body2"
          sx={{
            color: '#333',
            whiteSpace: 'pre-wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical',
            maxHeight: '100px',
            fontSize: '13px'
          }}
          title={(retorno ? retorno + '\n' : '') + (observacao || '')}
        >
          {(retorno ? retorno + '\n' : '') + (observacao || '')}
        </Typography>
      </Box>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSaveObservacao();
          }}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 550,
            height: 200,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 3,
            borderRadius: '4px',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 , marginTop: -1}}>
            <SpeakerNotesOutlined sx={{ fontSize: 20, color: '#0965c1', borderRadius: '4px' }} />
            <Typography variant="subtitle1" fontSize='18px' fontWeight={500} sx={{ lineHeight: 1, color: '#334155' }}>
              Observação do Pedido:
            </Typography>
          </Box>
          <Divider sx={{ width: '100%', marginBottom: 1, marginTop: -0.4 }} />
          <TextField
            id="modal-description"
            fullWidth
            multiline
            rows={4}
            value={inputValue}
            onChange={handleChangeObservacao}
            placeholder="Digite sua observação"
            autoFocus // já entra com cursor ativo
            sx={{ marginTop: 1, '& .MuiOutlinedInput-root': { borderRadius: '4px' } }}

          />
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: 1.25, marginTop: 2 }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCloseModal}
              tabIndex={4} // botão cancelar
              sx={{
                backgroundColor: "#EEFBFF",
                color: "#0965c1",
                minHeight: 30,
                fontSize: '14px',
                py: 0.4,
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',                
                borderRadius: '6px',
                padding: '0 12px',
                width: '20%',
                height: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'sans-serif',
                textTransform: 'none',
                
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveObservacao}
              tabIndex={3} // botão salvar
              sx={{
                backgroundColor: "#0965c1",
                color: "#fff",
                minHeight: 30,
                fontSize: '14px',
                py: 0.4,
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',               
                borderRadius: '6px',
                padding: '0 12px',
                width: '20%',
                height: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'sans-serif',
                textTransform: 'none',
              }}
            >
              Salvar
            </Button>
          </Box>
          {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
            <Button
              type="button"
              onClick={handleCloseModal}
              sx={{ marginRight: 1 }}
              tabIndex={-1} // ignora no TAB
            >
              Cancelar
            </Button>
            <Button
              type="submit" // Enter no foco chama salvar
              variant="contained"
            >
              Salvar
            </Button>
          </Box> */}
        </Box>
      </Modal>

    </Box>
  );
};

export default Observacao;
